import auth0 from 'auth0-js'
import EventEmitter from 'eventemitter3'
import router from './../router'
import axios from 'axios'

export default class AuthService {
	authenticated = this.isAuthenticated()
	authNotifier = new EventEmitter()

	constructor() {
		this.login = this.login.bind(this)
		this.setSession = this.setSession.bind(this)
		this.logout = this.logout.bind(this)
		this.isAuthenticated = this.isAuthenticated.bind(this)
	}

	auth0 = new auth0.WebAuth({
		domain: process.env.AUTH0_DOMAIN,
		clientID: process.env.AUTH0_CLIENT,
		redirectUri: process.env.AUTH0_CALLBACK,
		responseType: 'token id_token',
		scope: 'openid profile email'
	})

	login() {
		this.auth0.authorize()
	}

	handleAuthentication() {
		this.auth0.parseHash((err, authResult) => {
			if (authResult && authResult.accessToken && authResult.idToken) {
				this.setSession(authResult)
			} else if (err) {
				router.replace('UhOh')
				console.log(err)
				alert(`Error: ${err.error}. Check the console for further details.`)
			}
		})
	}

	setSession(authResult) {
		//time that the access token will expire at: 24 hours in milliseconds
		const EXPIRATION_MS = 86400000;

		let expiresAt = JSON.stringify(
			new Date().getTime() + EXPIRATION_MS
		)

		const processLogin = async (user) => {
			//Get a Protopia Member from the Auth0 user
			// console.log("Got user info", user);
			await axios.post(process.env.API_BASEURL + `dashboard/login`,
			{ member: user },
			{headers: {'Context': 'hermes'}}
			).then((member) => {
				if (member.data && member.data.success == false) {
					router.replace('UhOh')
					alert(`Invalid Authorization`)
				} else {
					localStorage.setItem('access_token', authResult.accessToken)
					localStorage.setItem('id_token', member.data.token)
					localStorage.setItem('auth0_token', authResult.idToken)
					localStorage.setItem('expires_at', expiresAt)
					localStorage.setItem('authUser', JSON.stringify(member.data.user));
					const user = member.data.user;
					if (user.role === 'SuperAdmin' || (user.communities && user.communities.length > 1)) {
						localStorage.removeItem('community_id');
						// Let Layout.vue handle the modal
						if (router.currentRoute.path !== '/home') {
							router.replace('home').catch(err => {});
						}
					} else {
						localStorage.setItem('community_id', user.communities[0]);
						if (router.currentRoute.path !== '/home') {
							router.replace('home').catch(err => {});
						}
					}
					this.authNotifier.emit('authChange', { authenticated: true })
				}
			})
			.catch((error) => {
				router.replace('UhOh');
				alert(`Invalid Authorization: ${error}`);
			});
		};

		if (authResult.idTokenPayload) {
			processLogin(authResult.idTokenPayload);
		} else {
			//Get the user info, then save that as authResult for access in components
			this.auth0.client.userInfo(authResult.accessToken, async (err, user) => {
				if (err) {
					console.log("Uh oh", err);
				} else {
					processLogin(user);
				}
			});
		}
	}

	logout() {
		// Clear access token and ID token from local storage
		localStorage.clear()
		this.userProfile = null
		this.authNotifier.emit('authChange', false)

		// Properly logout from Auth0 session
		try {
			this.auth0.logout({
				returnTo: `${window.location.origin}/login`,
				clientID: process.env.AUTH0_CLIENT
			})
		} catch (error) {
			console.error('Auth0 logout error:', error)
			// Fallback to manual redirect if Auth0 logout fails
			router.replace('/login')
		}
	}

	isAuthenticated() {
		// Check whether the current time is past the access token's expiry time
		try {
			let expiresAt = localStorage.getItem('expires_at')
			if (!expiresAt) {
				return false
			}

			const expirationTime = JSON.parse(expiresAt)
			const currentTime = new Date().getTime()
			return currentTime < expirationTime
		} catch (error) {
			console.error('Error checking authentication status:', error)
			return false
		}
	}
}



// WEBPACK FOOTER //
// ./src/services/AuthService.js